import apiClient from './apiClient';

export const widgetsApi = {
  list: async () => {
    const response = await apiClient.get('/widgets');
    return response.data;
  },
};
